import { render, staticRenderFns } from "./common-banner.vue?vue&type=template&id=471a9401&scoped=true"
import script from "./common-banner.vue?vue&type=script&lang=js"
export * from "./common-banner.vue?vue&type=script&lang=js"
import style0 from "./common-banner.vue?vue&type=style&index=0&id=471a9401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a9401",
  null
  
)

export default component.exports